'use client';
 
import Monitoring from '@/utils/monitoring';
import NextError from "next/error";
import { useEffect } from 'react';
 
export default function Error({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Monitoring.trackError(error);
  }, [error]);
 
  return (
    <NextError statusCode={0} />
  );
}